<mat-card appearance="raised" class="icon-card">
    <button *ngIf="config.toggleSwitch" mat-icon-button class="toggle-button" (click)="onFavClick()">
      <mat-icon class="star-icon" [@visibilityFade]="fav ? 'visible' : 'hidden'">star</mat-icon>
      <mat-icon class="star-border-icon">star_border</mat-icon>
    </button>

    <div class="image-container">
      <mat-card appearance="raised" class="image-card" (click)="onButtonClick(config?.iconClickResponse)">
        <img [ngSrc]="config.iconUrl" width="50" height="50"/>
      </mat-card>
    </div>

    <h3 class="title">{{ config.displayName }}</h3>

    <p class="subtitle">{{ config.displaySubtitle }}</p>

    <p *ngIf="!!config.displayDescription" class="small-description">{{ config.displayDescription }}</p>

    <div class="button-container">
      <button mat-raised-button
        *ngFor="let button of config.buttons"
        [ngClass]="button.buttonClassList"
        (click)="onButtonClick(button?.buttonClickResponse)">
          {{ button.buttonText }}
      </button>
    </div>
</mat-card>
